var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 7.205H1.83331V14.8408C1.83331 14.8958 1.83331 14.9508 1.84248 14.9967H10.3125V7.205Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04919 5.83H10.3125V1.83333H7.07669V5.71999C7.07669 5.75666 7.05836 5.79333 7.04919 5.83Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70168 5.72V1.98C3.66668 2.40166 2.33751 3.75833 1.95251 5.83H5.72001C5.71085 5.79333 5.70168 5.75666 5.70168 5.72Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8683 1.83333H11.6875V5.83H14.8683V1.83333Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2342 5.83001H20.0475C19.6625 3.74001 18.315 2.37417 16.2434 1.97084V5.80251C16.2434 5.81167 16.2342 5.82084 16.2342 5.83001Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2433 20.0292C18.2508 19.635 19.5708 18.3517 20.0017 16.3717H16.2433V20.0292Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8683 16.3717H11.6875V20.1667H14.8683V16.3717Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 14.9967H20.1575C20.1667 14.9508 20.1667 14.8958 20.1667 14.8408V7.205H11.6875V14.9967Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 16.3717H7.07666V20.1667H10.3125V16.3717Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99835 16.3717C2.42919 18.3333 3.73085 19.6167 5.70169 20.02V16.3717H1.99835Z",
    fill: "#EFEEE0",
    fillOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.b4c8981637c2a874ce253cc8a60fbea3.svg";
export { ForwardRef as ReactComponent };